export default "__VITE_ASSET__DbpLz2mM__"